import PropTypes from "prop-types";
import styled from "styled-components";

const Text = styled.p`
  color: ${({ color, theme }) => theme.color[color]};
  font-size: ${ ({ size }) => size }px;
  line-height: ${ ({ size }) => size + 10 }px;
  font-weight: ${({ weight }) => weight};
  font-family: 'Realtime Text', sans-serif;
`;

Text.propTypes = {
  as: PropTypes.oneOf(["p", "h1", "h2", "h3", "h4", "h5", "h6"]).isRequired,
  color: PropTypes.string,
  size: PropTypes.number,
  weight: PropTypes.oneOf([
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
  ])
};

Text.defaultProps = {
  as: "p",
  color: "dark",
  size: 15,
  weight: "500"
};

export default Text;
